<template>
  <div class="user">
    <div class="photo">
      <img src="static/img/faces/face-0.jpg" alt="user avatar"/>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
         <span>
           Admin
           <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <a href="#" @click.prevent="goToSettings">
                <span class="sidebar-mini-icon">S</span>
                <span class="sidebar-normal">Settings</span>
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="logout">
                <span class="sidebar-mini-icon">L</span>
                <span class="sidebar-normal">Logout</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { getAuth, signOut } from 'firebase/auth';

export default {
  components: {
    CollapseTransition,
  },
  data() {
    return {
      isClosed: true,
    };
  },
  methods: {
    toggleMenu() {
      this.isClosed = !this.isClosed;
    },
    async logout() {
      const auth = getAuth();
      try {
        await signOut(auth); // Sign out the user
        console.log('User logged out');
        this.$router.push('/login'); // Redirect to the login page
      } catch (error) {
        console.error('Error logging out:', error.message);
      }
    },
    goToSettings() {
      // Navigate to the settings route
      this.$router.push('/settings');
    },
  },
};
</script>

<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
